/**
 * TanStack Query hooks for `maxbounty-integration-via-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	maxbountyIntegrationViaApiQueryKeys,
	type CreateMaxbountyIntegrationViaApiBody,
	type ListMaxbountyIntegrationViaApiResponse,
	type MaxbountyIntegrationViaApiRow,
} from "./api";

export function useMaxbountyIntegrationViaApiList(): UseQueryResult<ListMaxbountyIntegrationViaApiResponse, Error> {
	return useQuery({
		queryKey: maxbountyIntegrationViaApiQueryKeys.list(),
		queryFn: list,
	});
}

export function useMaxbountyIntegrationViaApiCreate(): UseMutationResult<MaxbountyIntegrationViaApiRow, Error, CreateMaxbountyIntegrationViaApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: maxbountyIntegrationViaApiQueryKeys.all });
		},
	});
}

export function useMaxbountyIntegrationViaApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: maxbountyIntegrationViaApiQueryKeys.all });
		},
	});
}
